import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, WHATSAPP_NUMBER, WHATSAPP_DISPLAY } from "../lib/api";
import { useAuth } from "../lib/auth";
import { toast } from "sonner";
import WhatsAppButton from "../components/WhatsAppButton";
import ChatbotWidget from "../components/ChatbotWidget";
import BookingModal from "../components/BookingModal";
import TestimonialModal from "../components/TestimonialModal";

const LOGO = "https://images.leadconnectorhq.com/image/f_webp/q_90/r_2400/u_https://assets.cdn.filesafe.space/1Pgvl5LY255hW2daqEkL/media/e0daa283-ad96-467f-b669-0137f555a9bd.png";
const HERO_IMG = "https://images.leadconnectorhq.com/image/f_webp/q_90/r_2400/u_https://assets.cdn.filesafe.space/1Pgvl5LY255hW2daqEkL/media/6b57eac2-66f4-490d-9397-7e1ad117fd1e.jpeg";

// Fallback image per service category — used when DB has no image_url.
// All URLs verified to load reliably (mix of existing filesafe.space assets + verified Unsplash IDs).
const CATEGORY_FALLBACK = {
  "Waxing/Threading":              "https://images.unsplash.com/photo-1633681926022-84c23e8cb2d6?w=800&q=80&auto=format&fit=crop",
  "Massage":                       "https://images.leadconnectorhq.com/image/f_webp/q_90/r_2400/u_https://assets.cdn.filesafe.space/locatation/EVvyFhJsKaCpZugcRvRt/images/e7d2ccf5-fdb5-4218-9ec8-06574ccdfd22.png",
  "Body Treatments":               "https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=800&q=80&auto=format&fit=crop",
  "Facial Treatments":             "https://images.leadconnectorhq.com/image/f_webp/q_90/r_2400/u_https://assets.cdn.filesafe.space/1Pgvl5LY255hW2daqEkL/media/b3d54090-e36c-41df-8083-ece3206704dd.png",
  "Lashes":                        "https://images.unsplash.com/photo-1633681926022-84c23e8cb2d6?w=800&q=80&auto=format&fit=crop",
  "Brows":                         "https://images.unsplash.com/photo-1487412947147-5cebf100ffc2?w=800&q=80&auto=format&fit=crop",
  "Nail Services — Manicure":      "https://images.leadconnectorhq.com/image/f_webp/q_90/r_2400/u_https://assets.cdn.filesafe.space/1Pgvl5LY255hW2daqEkL/media/463031c3-4025-480b-b6ee-ace8fc542301.png",
  "Nail Services — Extensions":    "https://images.unsplash.com/photo-1604654894610-df63bc536371?w=800&q=80&auto=format&fit=crop",
  "Nail Services — Pedicure":      "https://images.leadconnectorhq.com/image/f_webp/q_90/r_2400/u_https://assets.cdn.filesafe.space/1Pgvl5LY255hW2daqEkL/media/39b24222-1a26-4c5b-a0eb-e47b7416323f.png",
  "Hair Services — Cut":           "https://images.leadconnectorhq.com/image/f_webp/q_90/r_2400/u_https://assets.cdn.filesafe.space/1Pgvl5LY255hW2daqEkL/media/800509ad-fc76-49ba-a860-67e2ce3fde37.png",
  "Hair Services — Color":         "https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?w=800&q=80&auto=format&fit=crop",
  "Hair Services — Treatments":    "https://images.leadconnectorhq.com/image/f_webp/q_90/r_2400/u_https://assets.cdn.filesafe.space/1Pgvl5LY255hW2daqEkL/media/800509ad-fc76-49ba-a860-67e2ce3fde37.png",
  "Hair Services — Style":         "https://images.leadconnectorhq.com/image/f_webp/q_90/r_2400/u_https://assets.cdn.filesafe.space/1Pgvl5LY255hW2daqEkL/media/800509ad-fc76-49ba-a860-67e2ce3fde37.png",
};
const DEFAULT_FALLBACK = "https://images.leadconnectorhq.com/image/f_webp/q_90/r_2400/u_https://assets.cdn.filesafe.space/1Pgvl5LY255hW2daqEkL/media/6b57eac2-66f4-490d-9397-7e1ad117fd1e.jpeg";
const serviceImage = (s) => s?.image_url?.trim() || CATEGORY_FALLBACK[s?.category] || DEFAULT_FALLBACK;

// Six hand-picked "Signature Services" shown on the homepage (full 76 service menu remains in the booking dropdown)
const FEATURED_NAMES = [
  "4D Ultra Lifting Facial",
  "Deluxe Manicure (Gel Polish)",
  "Basic Pedicure with Foot Spa",
  "Haircut",
  "Full Body Massage",
  "Brow Lamination",
];

const PROMOS = [
  "https://images.leadconnectorhq.com/image/f_webp/q_90/r_2400/u_https://assets.cdn.filesafe.space/EVvyFhJsKaCpZugcRvRt/media/673cd9d3f36e6076af743cad.jpeg",
  "https://images.leadconnectorhq.com/image/f_webp/q_90/r_2400/u_https://assets.cdn.filesafe.space/EVvyFhJsKaCpZugcRvRt/media/673cd8be1be019fd3748f57f.jpeg",
  "https://images.leadconnectorhq.com/image/f_webp/q_90/r_2400/u_https://assets.cdn.filesafe.space/EVvyFhJsKaCpZugcRvRt/media/673cd71ca4764d8057208466.jpeg",
  "https://images.leadconnectorhq.com/image/f_webp/q_90/r_2400/u_https://assets.cdn.filesafe.space/EVvyFhJsKaCpZugcRvRt/media/673cd86d1be019ff6548f560.jpeg",
  "https://images.leadconnectorhq.com/image/f_webp/q_90/r_2400/u_https://assets.cdn.filesafe.space/EVvyFhJsKaCpZugcRvRt/media/673cd94900a0d4ce23091b87.jpeg",
  "https://images.leadconnectorhq.com/image/f_webp/q_90/r_2400/u_https://assets.cdn.filesafe.space/EVvyFhJsKaCpZugcRvRt/media/673cd8ebf7e07a1b1afc49bf.jpeg",
];

const TEAM = [
  { name: "Nicholas Bryant", role: "Lead Esthetician", img: "https://images.leadconnectorhq.com/image/f_webp/q_90/r_2400/u_https://assets.cdn.filesafe.space/1Pgvl5LY255hW2daqEkL/media/51db2014-0e67-4ae0-950e-0ab3a1fefe52.png" },
  { name: "Victoria Morgan", role: "Body Contouring", img: "https://images.leadconnectorhq.com/image/f_webp/q_90/r_2400/u_https://assets.cdn.filesafe.space/1Pgvl5LY255hW2daqEkL/media/463031c3-4025-480b-b6ee-ace8fc542301.png" },
  { name: "Walter Jenkins", role: "Hair Stylist", img: "https://images.leadconnectorhq.com/image/f_webp/q_90/r_2400/u_https://assets.cdn.filesafe.space/1Pgvl5LY255hW2daqEkL/media/45466440-8d7c-4ac7-ae47-6579e237acc0.png" },
];

const FAQS = [
  { q: "What should I expect during my first visit?", a: "Your first visit begins with a comprehensive consultation where our experts assess your needs and discuss your beauty goals. We recommend personalized treatments and answer every question to ensure you feel comfortable." },
  { q: "Are your treatments safe?", a: "Yes — every treatment is performed by certified, highly trained professionals using state-of-the-art equipment. We adhere to the highest standards of hygiene and care." },
  { q: "How do I know which treatment is right for me?", a: "During your consultation we evaluate your skin, hair and goals to recommend the most suitable services. You can also chat with our AI concierge or message us on WhatsApp." },
  { q: "What are your opening hours?", a: "We welcome guests every day from 10:00 AM to 10:00 PM at our Mankhool, Dubai location." },
  { q: "Do I need to book in advance?", a: "Booking ahead guarantees your preferred therapist and time. Submit a request via the booking form — once approved by our team, you'll receive confirmation by phone or WhatsApp." },
];

export default function HomePage() {
  const [services, setServices] = useState([]);
  const [testimonials, setTestimonials] = useState([]);
  const [promotions, setPromotions] = useState([]);
  const [openFaq, setOpenFaq] = useState(0);
  const [bookingOpen, setBookingOpen] = useState(false);
  const [testimonialOpen, setTestimonialOpen] = useState(false);
  const [accountMenuOpen, setAccountMenuOpen] = useState(false);
  const { user } = useAuth();

  useEffect(() => {
    api.get("/services").then(r => setServices(r.data)).catch(() => {});
    api.get("/testimonials").then(r => setTestimonials(r.data)).catch(() => {});
    api.get("/promotions").then(r => setPromotions(r.data || [])).catch(() => setPromotions([]));
  }, []);

  // Close account menu when clicking outside (desktop fix — replaces buggy onMouseLeave)
  useEffect(() => {
    if (!accountMenuOpen) return;
    const handler = (e) => {
      if (!e.target.closest('[data-testid="account-menu-wrap"]')) {
        setAccountMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [accountMenuOpen]);

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="font-body text-[var(--text)]" data-testid="home-page">
      {/* NAV */}
      <header className="sticky top-0 z-40 backdrop-blur-md bg-[rgba(253,251,247,0.85)] border-b border-[var(--border)]">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
          <a href="#home" className="flex items-center gap-3" data-testid="nav-logo">
            <img src={LOGO} alt="Ayame Salon" className="h-12 w-auto" />
            <span className="font-display text-2xl tracking-tight hidden md:inline">Ayame Salon</span>
          </a>
          <nav className="hidden md:flex items-center gap-9 text-sm tracking-wide uppercase">
            <button onClick={() => scrollTo("services")} className="hover:text-[var(--accent)]" data-testid="nav-services">Services</button>
            <button onClick={() => scrollTo("offers")} className="hover:text-[var(--accent)]" data-testid="nav-offers">Offers</button>
            <button onClick={() => scrollTo("testimonials")} className="hover:text-[var(--accent)]" data-testid="nav-testimonials">Testimonials</button>
            <button onClick={() => scrollTo("faq")} className="hover:text-[var(--accent)]" data-testid="nav-faq">FAQ</button>
            <button onClick={() => scrollTo("contact")} className="hover:text-[var(--accent)]" data-testid="nav-contact">Contact</button>
          </nav>
          <button
            onClick={() => setBookingOpen(true)}
            className="btn-gold rounded-full px-6 py-2.5 text-sm tracking-wider uppercase hidden md:inline-block"
            data-testid="nav-book-btn"
          >
            Book Now
          </button>
          <div className="relative ml-2" data-testid="account-menu-wrap">
            <button
              onClick={() => setAccountMenuOpen(o => !o)}
              className="w-10 h-10 rounded-full border border-[var(--border)] flex items-center justify-center hover:border-[var(--accent)] hover:text-[var(--accent)] transition-colors"
              data-testid="nav-account-btn"
              aria-label="Account"
            >
              <i className="fa-regular fa-user"></i>
            </button>
            {accountMenuOpen && (
              <div className="absolute right-0 top-12 bg-white border border-[var(--border)] shadow-luxe min-w-[220px] z-50" data-testid="account-menu">
                {user ? (
                  <>
                    <div className="px-5 py-3 border-b border-[var(--border)]">
                      <p className="text-sm font-medium">{user.name}</p>
                      <p className="text-xs text-[var(--muted)] uppercase tracking-widest">{(user.role || "").replace("_", " ")}</p>
                    </div>
                    {user.role === "customer" && <Link to="/account" className="block px-5 py-3 text-sm hover:bg-[var(--bg)]" data-testid="menu-account">My Account</Link>}
                    {user.role === "agent" && <Link to="/staff" className="block px-5 py-3 text-sm hover:bg-[var(--bg)]" data-testid="menu-staff">Staff Dashboard</Link>}
                    {user.role === "receptionist" && <Link to="/reception" className="block px-5 py-3 text-sm hover:bg-[var(--bg)]" data-testid="menu-reception">Reception</Link>}
                    {user.role === "owner" && <Link to="/admin-owner" className="block px-5 py-3 text-sm hover:bg-[var(--bg)]" data-testid="menu-owner">Owner Console</Link>}
                    {user.role === "admin" && <Link to="/admin" className="block px-5 py-3 text-sm hover:bg-[var(--bg)]" data-testid="menu-admin">Admin Console</Link>}
                  </>
                ) : (
                  <>
                    <Link to="/login" className="block px-5 py-3 text-sm hover:bg-[var(--bg)] border-b border-[var(--border)]" data-testid="menu-customer-login">
                      <i className="fa-regular fa-user mr-2 text-[var(--accent)]"></i> Customer Login
                    </Link>
                    <Link to="/signup" className="block px-5 py-3 text-sm hover:bg-[var(--bg)] border-b border-[var(--border)]" data-testid="menu-customer-signup">
                      <i className="fa-solid fa-user-plus mr-2 text-[var(--accent)]"></i> Create Account
                    </Link>
                    <Link to="/staff/login" className="block px-5 py-3 text-sm hover:bg-[var(--bg)] border-b border-[var(--border)]" data-testid="menu-staff-login">
                      <i className="fa-solid fa-briefcase mr-2 text-[var(--accent)]"></i> Salon Staff
                    </Link>
                    <Link to="/reception/login" className="block px-5 py-3 text-sm hover:bg-[var(--bg)] border-b border-[var(--border)]" data-testid="menu-reception-login">
                      <i className="fa-solid fa-bell-concierge mr-2 text-[var(--accent)]"></i> Reception
                    </Link>
                    <Link to="/admin-owner/login" className="block px-5 py-3 text-sm hover:bg-[var(--bg)]" data-testid="menu-owner-login">
                      <i className="fa-solid fa-crown mr-2 text-[var(--accent)]"></i> Site Owner
                    </Link>
                  </>
                )}
              </div>
            )}
          </div>
        </div>
      </header>

      {/* HERO */}
      <section id="home" className="relative h-[88vh] min-h-[640px] hero-overlay overflow-hidden">
        <img src={HERO_IMG} alt="Ayame Salon" className="absolute inset-0 w-full h-full object-cover" />
        <div className="relative z-10 max-w-5xl mx-auto h-full flex flex-col justify-center items-center text-center px-6 text-white fade-up">
          <p className="uppercase text-[11px] tracking-[0.4em] text-[var(--accent)] mb-6">Your Personal Beauty Retreat</p>
          <h1 className="font-display text-5xl sm:text-6xl md:text-7xl lg:text-8xl leading-[0.95]">Experience<br /><em className="not-italic text-[var(--accent)]">True Elegance</em></h1>
          <p className="mt-8 max-w-xl text-lg font-light text-white/85">
            Discover expert stylists dedicated to creating your perfect look. A luxurious salon experience that promises to transform you today.
          </p>
          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <button onClick={() => setBookingOpen(true)} className="btn-gold rounded-full px-8 py-3 text-sm tracking-widest uppercase" data-testid="hero-book-btn">
              Make an Appointment
            </button>
            <a
              href={`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent("Hello Ayame Salon, I'd like to enquire about your services.")}`}
              target="_blank" rel="noreferrer"
              className="rounded-full px-8 py-3 text-sm tracking-widest uppercase border border-white/70 text-white hover:bg-white hover:text-[var(--primary)] transition-all"
              data-testid="hero-whatsapp-btn"
            >
              <i className="fa-brands fa-whatsapp mr-2"></i> Chat on WhatsApp
            </a>
          </div>
        </div>
      </section>

      {/* SERVICES */}
      <section id="services" className="py-16 md:py-24 lg:py-32 bg-[var(--bg)]">
        <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-10">
          <div className="flex flex-col md:flex-row md:items-end justify-between mb-10 md:mb-14 gap-4 md:gap-6">
            <div>
              <p className="uppercase text-[10px] sm:text-xs tracking-[0.3em] text-[var(--accent)] mb-2 sm:mb-3">Our Atelier</p>
              <h2 className="font-display text-3xl sm:text-4xl md:text-5xl lg:text-6xl">Signature Services</h2>
            </div>
            <p className="text-sm md:text-base text-[var(--muted)] max-w-md">Each treatment is hand-crafted by our master therapists — designed to leave you radiant, restored, and unmistakably you.</p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6" data-testid="services-grid">
            {FEATURED_NAMES.map(name => services.find(s => s.name === name)).filter(Boolean).map((s, i) => (
              <article key={s.id} className="group bg-white border border-[var(--border)] overflow-hidden hover:shadow-luxe transition-all duration-500" data-testid={`service-card-${s.slug}`}>
                <div className="aspect-[4/3] overflow-hidden bg-[var(--bg)]">
                  <img src={serviceImage(s)} alt={s.name} loading="lazy"
                       onError={(e) => { e.currentTarget.src = DEFAULT_FALLBACK; }}
                       className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                </div>
                <div className="p-4 sm:p-5 md:p-7">
                  <div className="flex items-baseline justify-between mb-1.5 sm:mb-2 gap-3">
                    <h3 className="font-display text-lg sm:text-xl md:text-2xl">{s.name}</h3>
                    <span className="text-[var(--accent)] font-medium text-sm md:text-base whitespace-nowrap">AED {s.price_aed}</span>
                  </div>
                  <p className="text-xs sm:text-sm text-[var(--muted)] mb-3 md:mb-4 leading-relaxed">{s.description}</p>
                  <div className="flex items-center justify-between text-[10px] sm:text-xs uppercase tracking-wider text-[var(--muted)]">
                    <span><i className="fa-regular fa-clock mr-1.5"></i>{s.duration_min} min</span>
                    <button onClick={() => setBookingOpen(true)} className="text-[var(--primary)] hover:text-[var(--accent)] transition-colors" data-testid={`service-book-${s.slug}`}>
                      Book →
                    </button>
                  </div>
                </div>
              </article>
            ))}
          </div>
          <div className="text-center mt-8 md:mt-12">
            <button onClick={() => setBookingOpen(true)}
              className="inline-flex items-center gap-2 border border-[var(--primary)] text-[var(--primary)] hover:bg-[var(--primary)] hover:text-white transition-all rounded-full px-6 sm:px-8 py-2.5 text-xs sm:text-sm tracking-widest uppercase"
              data-testid="view-full-menu-btn">
              View Full Menu — {services.length}+ Services <span aria-hidden>→</span>
            </button>
          </div>
        </div>
      </section>

      {/* OFFERS / PROMO */}
      <section id="offers" className="py-16 md:py-24 lg:py-32 bg-[#F6F2EA]">
        <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-10">
          <div className="text-center mb-10 md:mb-14">
            <p className="uppercase text-[10px] sm:text-xs tracking-[0.3em] text-[var(--accent)] mb-2 sm:mb-3">Limited Time</p>
            <h2 className="font-display text-3xl sm:text-4xl md:text-5xl lg:text-6xl">Promotions & Offers</h2>
            <div className="divider-line w-24 sm:w-32 mx-auto mt-4 md:mt-6"></div>
          </div>
          {promotions.length > 0 ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6" data-testid="promos-grid-live">
              {promotions.map(p => (
                <article key={p.id} className="bg-white border border-[var(--border)] overflow-hidden hover:shadow-luxe transition-all duration-500" data-testid={`promo-${p.id}`}>
                  {p.image_url && (
                    <div className="aspect-[4/3] overflow-hidden bg-[var(--bg)]">
                      <img src={p.image_url} alt={p.title} loading="lazy" className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" />
                    </div>
                  )}
                  <div className="p-5 md:p-6">
                    <div className="flex items-baseline justify-between mb-2 gap-3">
                      <h3 className="font-display text-xl md:text-2xl">{p.title}</h3>
                      {(p.discount_percent > 0 || p.discount_aed > 0) && (
                        <span className="bg-[var(--accent)] text-white text-[10px] uppercase tracking-widest px-2.5 py-1 whitespace-nowrap rounded-full">
                          {p.discount_percent > 0 ? `${p.discount_percent}% OFF` : `AED ${p.discount_aed} OFF`}
                        </span>
                      )}
                    </div>
                    {p.description && <p className="text-sm text-[var(--muted)] leading-relaxed mb-3">{p.description}</p>}
                    {p.valid_until && (
                      <p className="text-[10px] uppercase tracking-widest text-[var(--muted)]">
                        <i className="fa-regular fa-calendar mr-1.5"></i>Valid until {p.valid_until}
                      </p>
                    )}
                    <button onClick={() => setBookingOpen(true)} className="mt-4 text-xs uppercase tracking-widest text-[var(--accent)] hover:underline" data-testid={`promo-claim-${p.id}`}>
                      Claim this offer →
                    </button>
                  </div>
                </article>
              ))}
            </div>
          ) : (
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3" data-testid="promos-grid">
              {PROMOS.map((src, i) => (
                <div key={i} className={`overflow-hidden bg-white ${i % 5 === 0 ? "row-span-2" : ""}`}>
                  <img src={src} alt={`Promo ${i+1}`} className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" />
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* ALL TREATMENTS BANNER */}
      <section className="py-16 md:py-24 lg:py-32 bg-[var(--primary)] text-[var(--bg)]">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <p className="uppercase text-xs tracking-[0.3em] text-[var(--accent)] mb-4">Holistic Care</p>
          <h2 className="font-display text-3xl sm:text-4xl md:text-5xl lg:text-6xl mb-6 md:mb-8">All Kinds of Treatments</h2>
          <p className="text-white/70 text-lg leading-relaxed mb-10">
            At Ayame Salon, we offer a comprehensive range of treatments tailored to meet your unique beauty and wellness needs.
            Each service is designed to deliver exceptional results, ensuring you leave feeling revitalized, confident, and radiant.
          </p>
          <a href={`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent("I'd like a free consultation please.")}`} target="_blank" rel="noreferrer"
            className="inline-block btn-gold rounded-full px-10 py-3.5 text-sm tracking-widest uppercase" data-testid="free-consultation-btn">
            Free Consultation
          </a>
        </div>
      </section>

      {/* TEAM */}
      <section id="team" className="py-16 md:py-24 lg:py-32 bg-[var(--bg)]">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="text-center mb-14">
            <p className="uppercase text-xs tracking-[0.3em] text-[var(--accent)] mb-3">Meet The Team</p>
            <h2 className="font-display text-3xl sm:text-4xl md:text-5xl lg:text-6xl">Our Master Stylists</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {TEAM.map((t, i) => (
              <div key={i} className="text-center group" data-testid={`team-${i}`}>
                <div className="aspect-square overflow-hidden mb-5 border border-[var(--border)]">
                  <img src={t.img} alt={t.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                </div>
                <h3 className="font-display text-2xl">{t.name}</h3>
                <p className="text-sm text-[var(--muted)] uppercase tracking-wider mt-1">{t.role}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section id="testimonials" className="py-16 md:py-24 lg:py-32 bg-[#F6F2EA]">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="flex flex-col md:flex-row md:items-end justify-between mb-14 gap-6">
            <div>
              <p className="uppercase text-xs tracking-[0.3em] text-[var(--accent)] mb-3">Happy Guests</p>
              <h2 className="font-display text-3xl sm:text-4xl md:text-5xl lg:text-6xl">Testimonials</h2>
            </div>
            <button onClick={() => setTestimonialOpen(true)} className="btn-outline rounded-full px-7 py-2.5 text-sm tracking-widest uppercase self-start md:self-end" data-testid="share-experience-btn">
              <i className="fa-regular fa-pen-to-square mr-2"></i> Share Your Experience
            </button>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="testimonials-grid">
            {testimonials.map((t) => (
              <article key={t.id} className="bg-white border border-[var(--border)] p-8 flex flex-col" data-testid={`testimonial-${t.id}`}>
                <div className="text-[var(--accent)] mb-4 text-lg">
                  {"★".repeat(t.rating || 5)}
                </div>
                <p className="text-[var(--text)] leading-relaxed flex-1 italic font-display text-lg">"{t.message}"</p>
                <div className="flex items-center gap-3 mt-6 pt-6 border-t border-[var(--border)]">
                  {t.avatar ? (
                    <img src={t.avatar} alt={t.name} className="w-10 h-10 rounded-full object-cover" />
                  ) : (
                    <div className="w-10 h-10 rounded-full bg-[var(--accent)]/20 flex items-center justify-center font-display text-[var(--accent)]">
                      {t.name?.[0]}
                    </div>
                  )}
                  <div>
                    <p className="font-medium">{t.name}</p>
                    <p className="text-xs text-[var(--muted)] uppercase tracking-wider">{t.role}</p>
                  </div>
                </div>
              </article>
            ))}
            {testimonials.length === 0 && (
              <p className="text-[var(--muted)] col-span-full text-center">Be the first to share your experience!</p>
            )}
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section id="faq" className="py-24 md:py-32 bg-[var(--bg)]">
        <div className="max-w-4xl mx-auto px-6">
          <div className="text-center mb-12">
            <p className="uppercase text-xs tracking-[0.3em] text-[var(--accent)] mb-3">Good to Know</p>
            <h2 className="font-display text-3xl sm:text-4xl md:text-5xl lg:text-6xl">Frequently Asked</h2>
          </div>
          <div className="space-y-3" data-testid="faq-list">
            {FAQS.map((f, i) => (
              <div key={i} className="bg-white border border-[var(--border)]">
                <button onClick={() => setOpenFaq(openFaq === i ? -1 : i)}
                  className="w-full text-left px-7 py-5 flex justify-between items-center" data-testid={`faq-${i}`}>
                  <span className="font-display text-xl pr-6">{f.q}</span>
                  <i className={`fa-solid fa-plus text-[var(--accent)] transition-transform ${openFaq === i ? "rotate-45" : ""}`}></i>
                </button>
                {openFaq === i && (
                  <div className="px-7 pb-6 text-[var(--muted)] leading-relaxed">{f.a}</div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CONTACT */}
      <section id="contact" className="py-16 md:py-24 lg:py-32 bg-[var(--primary)] text-[var(--bg)]">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 grid md:grid-cols-2 gap-12 items-center">
          <div>
            <p className="uppercase text-xs tracking-[0.3em] text-[var(--accent)] mb-3">Visit Us</p>
            <h2 className="font-display text-3xl sm:text-4xl md:text-5xl lg:text-6xl mb-6 md:mb-8">Contact</h2>
            <div className="space-y-5 text-white/85">
              <div className="flex items-start gap-4">
                <i className="fa-solid fa-location-dot text-[var(--accent)] mt-1.5"></i>
                <p>Shop No. 123, Mezzanine Flr., Al-Hanaa Center,<br/>Mankhool Road, Al-Jaffiliya, Dubai, UAE</p>
              </div>
              <div className="flex items-center gap-4">
                <i className="fa-solid fa-phone text-[var(--accent)]"></i>
                <a href={`tel:+${WHATSAPP_NUMBER}`} className="hover:text-[var(--accent)]">{WHATSAPP_DISPLAY}</a>
              </div>
              <div className="flex items-center gap-4">
                <i className="fa-solid fa-envelope text-[var(--accent)]"></i>
                <a href="mailto:ayame.beautysalon1@gmail.com" className="hover:text-[var(--accent)]">ayame.beautysalon1@gmail.com</a>
              </div>
              <div className="flex items-center gap-4">
                <i className="fa-regular fa-clock text-[var(--accent)]"></i>
                <p>Open Daily · 10:00 AM — 10:00 PM</p>
              </div>
              <div className="flex gap-4 pt-4">
                <a href="https://www.facebook.com/ayamesalon" target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full border border-white/30 flex items-center justify-center hover:border-[var(--accent)] hover:text-[var(--accent)]"><i className="fa-brands fa-facebook-f"></i></a>
                <a href="https://www.instagram.com/ayamesalondubai/" target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full border border-white/30 flex items-center justify-center hover:border-[var(--accent)] hover:text-[var(--accent)]"><i className="fa-brands fa-instagram"></i></a>
                <a href="https://www.tiktok.com/@ayamesalon" target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full border border-white/30 flex items-center justify-center hover:border-[var(--accent)] hover:text-[var(--accent)]"><i className="fa-brands fa-tiktok"></i></a>
              </div>
            </div>
          </div>
          <div className="aspect-[4/3] overflow-hidden border border-white/10">
            <iframe
              title="Ayame Salon Map"
              src="https://www.google.com/maps?q=Al-Hanaa+Center+Mankhool+Road+Dubai&output=embed"
              width="100%" height="100%" style={{border:0, filter: "grayscale(0.4) contrast(1.05)"}}
              loading="lazy" referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="bg-[var(--primary)] text-white/70 py-10 border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 flex flex-col md:flex-row justify-between items-center gap-4 text-sm">
          <div className="flex items-center gap-3">
            <img src={LOGO} alt="Ayame" className="h-8 w-auto" />
            <span className="font-display text-xl text-white">Ayame Salon</span>
          </div>
          <p data-testid="footer-credit" className="font-display text-base text-white">
            Made By: <span className="text-[var(--accent)] tracking-wide">Ayame Salon</span>
          </p>
          <p className="text-xs">© 2026 Ayame Salon. All Rights Reserved.</p>
        </div>
      </footer>

      {/* Floating widgets */}
      <WhatsAppButton />
      <ChatbotWidget />

      {/* Modals */}
      <BookingModal open={bookingOpen} onClose={() => setBookingOpen(false)} services={services} />
      <TestimonialModal open={testimonialOpen} onClose={() => setTestimonialOpen(false)} />
    </div>
  );
}
